module.exports = __webpack_public_path__ + "static/media/logo-gergo-app.0b57b8bd.png";